import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import {mapState, mapGetters , mapMutations, mapActions} from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      visitorInfo: 'visitorInfo',
      config: 'config',
      channelGroupVoList: 'channelGroupVoList',
      noticeEvaluate: 'noticeEvaluate'
    }),
    ...mapGetters({
      serviceId: 'serviceId'
    })
  },
  methods: {
    ...mapMutations({
      set_accessDetail: 'set_accessDetail',
      setVisitorInfo: 'setVisitorInfo',
      set_queueTips: 'set_queueTips',
      set_config: 'set_config',
      set_bOnlineVisitor: 'set_bOnlineVisitor', // 设置是否在在线
      set_LeaveTitle: 'set_LeaveTitle',
      set_visitorBasicInfo: 'set_visitorBasicInfo',
      set_service: 'set_service',
      set_history: 'set_history',
      set_accessLog: 'set_accessLog',
      set_currentGroup: 'set_currentGroup',
      clearGroupUnreadyNum: 'clearGroupUnreadyNum',
      onlyUpdateGroupStatus: 'onlyUpdateGroupStatus',
      updateGroupListById: 'updateGroupListById',
      set_noticeEvaluate: 'set_noticeEvaluate',
      set_feedBackConfig: 'set_feedBackConfig',
      set_leaveMesageConfig: 'set_leaveMesageConfig',
      set_channelGroupVoList: 'set_channelGroupVoList'
    }),
    ...mapActions({
      get_skillGroupAll: 'get_skillGroupAll',
      // transferLabor: 'transferLabor',
      get_queue: 'get_queue'
    }),
    visitorJoin (msg) {
      // if (msg.service.groupId === this.$store.getters.groupId) { // 接入的会话的技能组如果是当选中的技能组
      // }
      this.setBaseServiceInfo(msg) // 更新当前信息
      let obj = {
        groupId: msg.service.groupId,
        status: '1',
        service: msg.service,
        history: msg.history,
        accessLog: msg.accessLog
      }
      this.updateGroupListById(obj)
      this.setVisitorInfo({ ...msg.service })
    },
    visitorQueue (msg) {
      this.set_queueTips(msg.content)
      this.onlyUpdateGroupStatus({groupId: msg.groupId, status: '2'})
    },
    setBaseServiceInfo (msg) { // 设置当前会话的基本信息
      console.log(msg, 'msg---')
      let service = msg.service || {
        channel: {}
      }
      service.channel = service.channel || {}
      let history = msg.history || {
        services: []
      }
      history.services = history.services || []
      let accessLog = msg.accessLog || {
        features: {}
      }
      accessLog.features = accessLog.features || {}
      // if (msg.service) {
      this.set_currentGroup({
        groupId: msg.groupId || msg.service.groupId, // 技能组id
        groupName: msg.groupName || msg.service.groupName, // 渠道名称
        visitStatus: msg.visitStatus, // 访客在该技能组的状态
        unreadMsgCount: msg.unreadMsgCount, // 未读消息数量
      })
      // }
      this.set_service(service) // 设置当前会话
      console.log(history, 'history')
      this.set_history(history) // 设置当前会话的历史服务
      this.set_accessLog(accessLog)
    },
    // 获取满意度配置
    getConfigInfo () {
      let vis = this.$store.state.visitorInfo;
      let params = {
        tenantId: vis.tenantId ? vis.tenantId : '',
        visitorId: vis.visitorId
      }
      ajax.get(apis.satisfaction.configInfo, {params}).then((res) => {
        if (res.success) {
          let obj = {}
          res.data.forEach((ev) => {
            if (ev.configCode == 'show.satisfaction') { // 满意度是否开启
              obj.isOpen = ev.enable == 1
            } else if (ev.configCode == 'end.evaluate') { // 会话结束主动邀评
              obj.endEvaluate = ev.enable == 1
            } else if (ev.configCode === 'result.remind') {  // 评价结果信息提醒
              obj.resultRemind = ev.enable == 1
            } else if (ev.configCode == 'evaluate.invite') { // 评价邀请语
              obj.evaluateInvite = ev.enable == 1
            } else if (ev.configCode === 'evaluate.thank') { // 评价感谢语
              obj.evaluateThank = ev.enable == 1
            } else if (ev.configCode == 'criterion') { // 评价标准设置
              obj.criterion = ev.enable == 1
            } else if (ev.configCode === 'dissatisfied.cause') { // 不满意原因设置
              obj.dissatisfiedCause = ev.enable == 1
            } else if (ev.configCode == 'opinion.feedback') { // 意见反馈框
              obj.opinionFeedback = ev.enable == 1
            }
          })
          this.set_feedBackConfig(obj)
        }
      })
    },
    // 获取留言配置
    getleaveMessageConfigList () {
      let params = {
        tenantId: this.visitorInfo.tenantId,
        enable: 1
      }
      ajax.get(apis.leaveMessage.configList, {params}).then((res) => {
        if (res.success) {
          let obj = {}
          res.data.leaveMessageFormConfigList.forEach((ev) => {
            if (ev.configCode == 'message_button') { // 留言按钮是否显示
              obj.isShowButton = ev.enable == 1
            } else if (ev.configCode == 'message_opens') { // 留言功能是否开启
              obj.isOpen = ev.enable == 1
            } else if (ev.configCode == 'message_title') { // 留言标题
              obj.isShowTitle = ev.enable == 1
            }
          })
          this.set_leaveMesageConfig(obj)
        }
      })
    },
    // 获得访客信息
    getVisitorInfo () {

      // 链接跳转过来对visitorName以及visitorPhone的处理
      console.log(this.$route, '---------')
      const visitorPhone = this.$route.query.visitorPhone
      const visitorName = this.$route.query.visitorName
      if (localStorage.newVisitorId && !this.visitorInfo.visitorId) {
        this.setVisitorInfo({visitorId: localStorage.newVisitorId})
        // 是否显示满意度
        this.getConfigInfo()
        // 是否显示留言
        this.getleaveMessageConfigList()
      }
      let params = {
        visitorId: localStorage.newVisitorId || this.visitorInfo.visitorId,
        visitorName,
        visitorPhone,
        source: {
          platformId: 'self',
          platformName: 'self',
          tenantId: this.visitorInfo.tenantId,
          tenantName: this.visitorInfo.tenantName,
          typeId: this.visitorInfo.typeId, // 大渠道
          typeName: this.visitorInfo.typeName,
          channelCode: this.visitorInfo.channelCode, // 小渠道
          channelName: this.visitorInfo.channelName
        }
      }
      ajax.post(apis.chat.visitorInfo, params).then((res) => {
        if (res.success) {
          // 获取技能组列表
          let channelGroupVoList = (res.data || {}).channelGroupVoList || []
          // 访客的基本信息
          let visitorBasicInfo = res.data.visitorBasicInfo || {}
          this.set_visitorBasicInfo(visitorBasicInfo)
          if (visitorBasicInfo.visitorId || !this.visitorInfo.visitorId) {
            localStorage.setItem('newVisitorId',  visitorBasicInfo.visitorId)
            localStorage.newVisitorId = visitorBasicInfo.visitorId
          }
          let obj = {
            visitorId: visitorBasicInfo.visitorId,
            visitorName: visitorBasicInfo.visitorName,
            mobilePhone: visitorBasicInfo.mobilePhone,
            extInfo: visitorBasicInfo.extInfo
          }
          this.setVisitorInfo(obj)
          if (this.$root.socket) { // 如果socket 连接上了则不需要再次连接socket
            this.isChooseGroupList(channelGroupVoList)
          } else { // 如果socket没连接上， 则需要先连接socket 才可转接会话
            this.init_socket().then(() => {
              this.isChooseGroupList(channelGroupVoList)
            })
          }
          // 是否显示满意度
          this.getConfigInfo()
          // 是否显示留言
          this.getleaveMessageConfigList()
        }
      })
    },
    isChooseGroupList (channelGroupVoList) {
      // 判断访客是否已经在会话中
      let channelGroupVoListItem = channelGroupVoList.filter(item => {
        return item.service || item.visitStatus === '1'
      })
      this.$store.commit('set_channelGroupVoListItem', channelGroupVoListItem)
      if (channelGroupVoListItem.length > 0) {
        if (this.visitorInfo.groupId) {
          // 如果在会话中并且访客有自己的groupId
          channelGroupVoListItem.forEach((ev) => {
            if (ev.groupId === this.visitorInfo.groupId) {
              // 找到对应的技能组 获取相应的信息
              this.selectedSkill(ev)
            }
          })
        } else {
          // 会话中，访客没有自己的groupId,那么就默认获取第一个技能组的相关信息
          this.selectedSkill(channelGroupVoListItem[0])
        }
      } else if (channelGroupVoList.length > 0 && !this.directConnect) {
        // 有技能组的情况  只能获取历史数据\离线数据  然后让访客自己选择技能组
        this.set_channelGroupVoList(channelGroupVoList)
      } else if (this.directConnect) {
        // this.transferArtifical()
        // 如果是短信跳转需要找到指定的技能组，并添加相应的信息
        let groupItem = (channelGroupVoList || []).find(item => item.groupId === this.visitorParams.groupId) || channelGroupVoList[0] || {}
        for (const key in groupItem) {
          if (!this.visitorParams.hasOwnProperty(key)) {
            this.visitorParams[key] = groupItem[key]
          }
        }
        let params = this.directConnect ? this.visitorParams : channelGroupVoList[0]
        this.selectedSkill(params)
        // let params = this.directConnect ? this.visitorParams : channelGroupVoList[0]
        // this.selectedSkill(params)
        // this.set_channelGroupVoList(channelGroupVoList)
        // if (this.visitorInfo.groupId) {
        //   channelGroupVoList.forEach((ev) => {
        //     if (ev.groupId === this.visitorInfo.groupId) {
        //       this.selectedSkill(ev)
        //     }
        //   })
        // } else {
        //   this.selectedSkill(channelGroupVoList[0])
        // }
      }
    },
    // 选择技能组
    selectedSkill (item) {
      let groupObj = {
        groupId: item.groupId,
        groupName: item.groupName
      }
      this.setVisitorInfo(groupObj)
      // 这个方法会设置一些基本信息  比较重要的是实时数据以及历史数据都是通过这个方法拿到的
      // 因为 会有组件对 groupId进行监听  从而拿到对应的数据  比如说实时聊天数据  客服离线所发的数据也属于实时聊天数据
      this.setBaseServiceInfo(item)
      this.clearGroupUnreadyNum(item.groupId)
      this.$bus.$emit('canRequestMsg')
      if (item.visitStatus === '1') { // 正在会话中
        this.setBaseServiceInfo(item)
      } else if (item.visitStatus === '2') { // 排队中
        this.get_queue()
      } else { // 未访问
        // 转接会话
        // 如果访客属于离线的状态就会执行这里   拿到一些系统消息  比如当前客服不在线
        if (this.directConnect) {
          this.transferArtifical()
          return
        }
        this.transferLabor()
      }
      if (this.noticeEvaluate[this.serviceId]) {
        this.$bus.$emit('showFeed', '') // 显示评价弹窗
      }
    },
    // 获得渠道信息
    getCannelInfo () {
      let params = {id: +this.visitorInfo.channelCode, tenantId: +this.visitorInfo.tenantId}
      ajax.get(apis.channel.detial, {params}).then((res) => {
        console.log(res, '渠道信息')
        if (res.success) {
          if (res.data) {
            document.title = res.data.title
            this.set_config(res.data)
            this.$i18n.locale = res.data && res.data.language || 'zh'
          }
        }
      })
    },
    // 初始化
    init () {
      this.getVisitorInfo()
    },
    // 结束会话
    endChat () {
      if (this.groupStatus !== '1') {
        return
      }
      // finish
      let params = {
        tenantId: this.visitorInfo.tenantId,
        groupId: this.visitorInfo.groupId,
        serviceId: this.serviceId
      }
      ajax.get(apis.chat.finish, {params}).then((res) => {
        if (res.success) {
          /* this.onlyUpdateGroupStatus({
            groupId: params.groupId,
            status: '3'
          }) */
          if (this.$message) {
            this.$message.success(res.message)
          }
          if (this.$toast) {
            this.$toast(res.message)
          }
        } else {
          if (this.$message) {
            this.$message.error(res.message)
          }
          if (this.$toast) {
            this.$toast(res.message)
          }
        }
      })
    },
    transferArtifical () {
      const params = {
        visitor: {
          visitorId: this.visitorInfo.visitorId,
          visitorName: this.visitorInfo.visitorName,
          mobilePhone: this.visitorInfo.mobilePhone,
          extInfo: this.visitorInfo.extInfo
        },
        request: {
          tenantId: this.visitorInfo.tenantId,
          groupId: this.visitorInfo.groupId,
          groupName: this.visitorInfo.groupName,
          targetAgentId: this.targetAgentId || ''
        },
        source: {
          platformId: 'self',
          platformName: 'self',
          tenantId: this.visitorInfo.tenantId,
          tenantName: this.visitorInfo.tenantName,
          typeId: this.visitorInfo.typeId, // 大渠道
          typeName: this.visitorInfo.typeName,
          channelCode: this.visitorInfo.channelCode, // 小渠道
          channelName: this.visitorInfo.channelName
        },
        features: {
          ip: '',
          region: '',
          terminal: '',
          os: '',
          accessProxy: '',
          language: this.config.language === 'zh' ? 0 : 1
        },
        authInfo: {
          id: '',
          account: '',
          name: '',
          test: ''
        },
        directConnect: this.directConnect || false
      }
      this.$root.socket.emit('request', params, (res) => {})
    },
    transferLabor () {
      console.log(this.visitorInfo.mobilePhone, 'this.visitorInfo.mobilePhone')
      let params = {
        visitor: {
          visitorId: this.visitorInfo.visitorId,
          visitorName: this.visitorInfo.visitorName,
          mobilePhone: this.visitorInfo.mobilePhone,
          extInfo: this.visitorInfo.extInfo
        },
        request: {
          tenantId: this.visitorInfo.tenantId,
          groupId: this.visitorInfo.groupId,
          groupName: this.visitorInfo.groupName,
          targetAgentId: this.targetAgentId || ''
        },
        source: {
          platformId: 'self',
          platformName: 'self',
          tenantId: this.visitorInfo.tenantId,
          tenantName: this.visitorInfo.tenantName,
          typeId: this.visitorInfo.typeId, // 大渠道
          typeName: this.visitorInfo.typeName,
          channelCode: this.visitorInfo.channelCode, // 小渠道
          channelName: this.visitorInfo.channelName
        },
        features: {
          ip: '',
          region: '',
          terminal: '',
          os: '',
          accessProxy: '',
          language: this.config.language === 'zh' ? 0 : 1
        },
        authInfo: {
          id: '',
          account: '',
          name: '',
          test: ''
        },
        directConnect: this.directConnect || false
      }
      ajax.post(apis.chat.switchLabor, params).then((res) => {
        if (!res.success) {
          // this.$message.error(res.message)
        }
      })
    }
  }
}
